import { STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';

const BiddersPipelineFilters = [
	{
		displayName: 'Requested',
		name: 'requested',
		filter: { status: 'requested' },
		icon: 'icons8-new-post',
		iconStyle: { color: '#4a1e87' },
	},
	{
		displayName: 'Interested',
		name: 'interested',
		filter: { status: 'interested' },
		icon: 'icons8-chat-bubble',
		iconStyle: { color: STOPLIGHT_COLORS.yellowGreen },
	},
	{
		displayName: 'Submitted',
		name: 'submitted',
		filter: { status: 'submitted' },
		icon: 'icons8-sent-filled',
		iconStyle: { color: STOPLIGHT_COLORS.pureYellow },
	},
	{
		displayName: 'Under Review',
		name: 'underReview',
		filter: { status: 'underReview' },
		icon: 'icons8-opera-glasses',
		iconStyle: { color: STOPLIGHT_COLORS.pureYellow },
	},
	{
		displayName: 'Awarded',
		name: 'awarded',
		filter: { status: 'awarded' },
		icon: 'icons8-trophy',
		iconStyle: { color: STOPLIGHT_COLORS.pureYellow },
	},
	{
		displayName: 'Declined',
		name: 'declined',
		filter: { status: 'declined' },
		icon: 'icons8-cancel-filled',
		iconStyle: { color: STOPLIGHT_COLORS.pureRed },
	},
	{
		displayName: 'Not Participating',
		name: 'notParticipate',
		filter: { status: 'notParticipate' },
		icon: 'icons8-snooze',
		iconStyle: { color: '#4a1e87' },
	},
];

export default BiddersPipelineFilters;
